﻿import { expand, collapse, getDisplayDate } from '../../util.js'
import { PAYLOAD } from '../home.js'
import News from './News.js'
import Comment from './Comment.js'
import dayjs from '../lib/dayjs.min.js'

export class SingleStatistics extends window.HTMLElement {
  constructor () {
    super()

    this.attachShadow({ mode: 'open' })
    const template = document.querySelector('#single-statistics-template')
    this.shadowRoot.appendChild(template.content.cloneNode(true))
  }

  connectedCallback () {
    this.slideIn()

    this._newsId = Number(this.dataset.newsId)
    this._payloadNews = PAYLOAD.find(x => x.ID === this._newsId)

    window.fetch(`/HR/api/getstatistics.aspx?newsid=${this._newsId}&type=all`)
      .then(res => (res.json()))
      .then(data => {
        const likes = data.filter(x => x.Type === 'likes')
        const comments = data.filter(x => x.Type === 'comments')
        const readCount = data.filter(x => x.Type === 'readcount')
        const unreadCount = data.filter(x => x.Type === 'unreadcount')
        const polls = data.filter(x => x.Type === 'poll')

        this._payloadNews.Likes = likes.length
        this._payloadNews.Comments = comments.length
        this._payloadNews.ReadCount = readCount.length
        this._payloadNews.UnreadCount = unreadCount.length
        this._payloadNews.PollAnswerCount = polls.length

        this.setVariables()
        this.setText()
        this.setHeight()
        this.setStatistics(data)
        this.setEventListeners()

        this.shadowRoot.querySelector('.loading').classList.add('hidden')
        this.shadowRoot.querySelector('.single-stats').classList.remove('hidden')
      })
      .catch(err => {
        console.error(err)
      })
  }

  setVariables () {
    this._news = new News(this._payloadNews)
    this._newsInList = document.querySelector(`.single-news[data-id='${this._newsId}']`)
    this._container = this.shadowRoot.querySelector('#single-stats-container')
    this._btnClose = this.shadowRoot.querySelector('#btn-back-single-stats')
    this._likes = this.shadowRoot.querySelector('#likes')
    this._comments = this.shadowRoot.querySelector('#comments')
    this._readCount = this.shadowRoot.querySelector('#read-count')
    this._unreadCount = this.shadowRoot.querySelector('#unread-count')
    this._pollCount = this.shadowRoot.querySelector('#poll-count')
    this._stats = this.shadowRoot.querySelectorAll('.stat')
    this._newsTitle = this.shadowRoot.querySelector('#news-title')
  }

  setText () {
    const span = document.createElement('span')
    span.textContent = this._news.Title

    const a = document.createElement('a')
    a.href = `/HR/api/getstatistics.aspx?newsid=${this._newsId}&export=true`
    a.textContent = 'Exportera statistik'
  
    this._newsTitle.append(span, a)
  }

  setHeight () {
    this._container.style.height = this.offsetHeight + 'px'
  }

  setStatistics (data) {
    this._likes.textContent = this._news.Likes + ` ${lang_has_liked}`
    this._likes.dataset.count = this._news.Likes

    this._comments.textContent = this._news.Comments + ` ${lang_has_commented}`
    this._comments.dataset.count = this._news.Comments

    this._readCount.textContent = this._news.ReadCount + ` ${lang_has_read}`
    this._readCount.dataset.count = this._news.ReadCount

    this._unreadCount.textContent = this._news.UnreadCount + ` ${lang_has_not_read}`
    this._unreadCount.dataset.count = this._news.UnreadCount

    this._pollCount.textContent = this._news.PollAnswerCount + ` ${lang_has_voted}`
    this._pollCount.dataset.count = this._news.PollAnswerCount

    if (this._news.HasPoll) {
      this.shadowRoot.querySelector('[data-type="poll"]').classList.remove('hidden')
    }

    this._stats.forEach(el => {
      const heading = el.querySelector('.heading')
      const count = el.querySelector('span').dataset.count
      const accordion = el.querySelector('.accordion')
      const dataType = el.dataset.type

      const inner = el.querySelector('.inner')

      if (count === '0') {
        heading.classList.add('zero')
      }

      if (dataType === 'poll') {
        this.setPollStatistics(data.filter(x => x.Type === dataType), inner)
      }

      heading.addEventListener('click', () => {
        if (heading.classList.contains('zero')) return

        const isOpen = accordion.getAttribute('data-collapsed') === 'false'

        if (isOpen) {
          collapse(accordion)
          el.classList.remove('active')

          return
        }

        el.classList.add('active')
        const fetchData = accordion.dataset.fetchData === 'true'

        if (fetchData) {
          expand(accordion)

          inner.innerHTML = ''

          if (dataType === 'readcount' || dataType === 'unreadcount') {
            const btnSendNotification = this.createReminderButton(dataType)

            inner.appendChild(btnSendNotification)
          }

          this.setDetailedStatistics(data.filter(x => x.Type === dataType), inner, dataType)
          accordion.dataset.fetchData = 'false'
          expand(accordion) // re-expand
        } else {
          expand(accordion)
        }
      })
    })
  }

  createReminderButton (dataType) {
    console.log(dataType)

    const btnSendNotification = document.createElement('div')
    btnSendNotification.classList = 'btn-send-reminder'

    const span = document.createElement('span')
    span.textContent = lang_send_reminder_push

    const spinner = document.createElement('div')
    spinner.classList = 'fas fa-spinner fa-pulse'

    btnSendNotification.append(span, spinner)

    btnSendNotification.addEventListener('click', e => {
      if (btnSendNotification.dataset.sent === 'true') {
        return
      }

      btnSendNotification.dataset.sent = 'true'
      spinner.style.display = 'inline-flex'
      span.style.display = 'none'

      let url = ''

      if (dataType === 'readcount') { url = `/HR/api/createnewsreminderread.aspx?news-id=${this._newsId}` } else if (dataType === 'unreadcount') { url = `/HR/api/createnewsreminder.aspx?news-id=${this._newsId}` }

      window.fetch(url)
        .then(res => {
          if (res.ok) {
            res.text().then(x => console.log(x))

            span.textContent = lang_reminder_sent
            span.style.display = 'inline-block'
            spinner.style.display = 'none'
            btnSendNotification.classList.add('success')
          }
        })
        .catch(err => {
          console.log(err)
          btnSendNotification.textContent = lang_something_wrong_reload
        })
    })

    return btnSendNotification
  }

  setPollStatistics (data, inner) {
    inner.innerHTML = ''

    console.log(data)

    for (let i = 0; i < data.length; i++) {
      const wrap = document.createElement('div')
      wrap.classList = 'stat-detailed'

      const top = document.createElement('div')
      top.classList = 'stat-detailed-top'

      const content = document.createElement('div')
      content.classList = 'stat-detailed-answer'
      content.textContent = data[i].Content

      const name = document.createElement('p')
      name.classList = 'stat-detailed-username'
      name.textContent = data[i].UserName

      top.appendChild(name)
      wrap.append(top, content)

      inner.appendChild(wrap)
    }
  }

  setDetailedStatistics (data, element, type) {
    for (let i = 0; i < data.length; i++) {
      const wrap = document.createElement('div')
      wrap.classList = 'stat-detailed'

      const top = document.createElement('div')
      top.classList = 'stat-detailed-top'

      const name = document.createElement('p')
      name.classList = 'stat-detailed-username'
      name.textContent = data[i].UserName

      const when = document.createElement('p')
      when.classList = 'stat-detailed-when'
      when.textContent = getDisplayDate(data[i].When)

      top.appendChild(name)

      if (type !== 'unreadcount') {
        top.appendChild(when)
      }

      wrap.appendChild(top)

      if (data[i].Content !== '') {
        const content = document.createElement('div')
        content.classList = 'stat-detailed-content'
        content.textContent = data[i].Content

        wrap.appendChild(content)
      }

      element.appendChild(wrap)

      if (type === 'comments') {
        this.setupRemoveComments(data[i], wrap)
      }
    }
  }

  setupRemoveComments (data, element) {
    const edit = document.createElement('div')
    edit.classList = 'single-comment-edit'

    const editWrap = document.createElement('div')
    editWrap.classList = 'edit-wrap'

    const removeText = document.createElement('p')
    removeText.classList = 'active'
    removeText.textContent = lang_remove_comment

    const iconWrap = document.createElement('div')
    iconWrap.classList = 'icon-wrap'

    const removeComment = document.createElement('i')
    removeComment.classList = 'fas fa-check'

    const times = document.createElement('i')
    times.classList = 'fas fa-times'

    const close = document.createElement('div')
    close.classList.add('close-edit-comment')

    const times2 = document.createElement('i')
    times2.classList = 'fas fa-times'

    iconWrap.appendChild(removeComment)
    iconWrap.appendChild(times)

    editWrap.appendChild(removeText)
    editWrap.appendChild(iconWrap)
    close.appendChild(times2)
    edit.appendChild(editWrap)
    edit.appendChild(close)

    element.appendChild(edit)

    element.addEventListener('click', e => {
      if (!edit.contains(e.target)) {
        element.classList.add('hide-content')
        edit.classList.add('active')
      }
    })

    removeComment.addEventListener('click', () => {
      const comment = new Comment()
      comment.ID = Number(data.StatID)
      comment.NewsRef = this._news.ID
      comment.Deleted = 'true'
      comment.Created = dayjs().format()

      window.fetch('/HR/api/createcomment.aspx', {
        method: 'POST',
        body: JSON.stringify(comment),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(res => {
          if (res.status === 200) {
            const accordion = element.parentElement.parentElement
            const elementHeight = element.scrollHeight

            const commentSpan = this._newsInList.querySelector('.single-news-comments span')
            this._news.Comments--
            this._payloadNews.Comments--

            commentSpan.textContent = this._news.Comments === 1 ? `${this._news.Comments} ${lang_a_comment}` : `${this._news.Comments} ${lang_comments}`
            this._comments.textContent = `${this._news.Comments} ${lang_has_commented}`

            element.remove()

            if (this._news.Comments !== 0) {
              accordion.style.height = accordion.scrollHeight - elementHeight + 'px'
            } else {
              collapse(accordion)
              const commentEl = this.shadowRoot.querySelector('.stat.comments')
              commentEl.classList.remove('active')
              commentEl.querySelector('.heading').classList.add('zero')
            }
          }
        })
        .catch(err => console.error(err))
    })

    times.addEventListener('click', () => {
      removeText.classList.add('active')
      iconWrap.classList.remove('active')
    })

    times2.addEventListener('click', () => {
      element.classList.remove('hide-content')
      edit.classList.remove('active')
      removeText.classList.add('active')
      iconWrap.classList.remove('active')
    })

    removeText.addEventListener('click', () => {
      removeText.classList.remove('active')
      iconWrap.classList.add('active')
    })

    this.shadowRoot.addEventListener('click', e => {
      const isClickInside = element.contains(e.target)
      const editIsActive = edit.classList.contains('active')

      if (!isClickInside && editIsActive) {
        element.classList.remove('hide-content')
        edit.classList.remove('active')
        removeText.classList.add('active')
        iconWrap.classList.remove('active')
      }
    })
  }

  setEventListeners () {
    this._btnClose.addEventListener('click', () => {
      document.documentElement.classList.remove('no-scroll')
      this.slideOutAndDelete()
    })
  }

  slideIn () {
    this.classList.add('active')
  }

  slideOutAndDelete () {
    this.classList.remove('active')
    document.documentElement.classList.remove('no-scroll')
    document.querySelector('.page-home')?.classList.remove('no-scroll')

    setTimeout(() => {
      this.remove()
    }, 310)
  }
}

// Define custom element
window.customElements.define('single-statistics', SingleStatistics)
